import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import LoginPage from "@/pages/LoginPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import PublicEnrollmentPage from "@/pages/PublicEnrollmentPage";
import DashboardLayout from "@/components/DashboardLayout";
import DashboardHome from "@/pages/DashboardHome";
import ClassiPage from "@/pages/ClassiPage";
import CalendarioPage from "@/pages/CalendarioPage";
import ConferenzePage from "@/pages/ConferenzePage";
import PresenzePage from "@/pages/PresenzePage";
import AnagrafichePage from "@/pages/AnagrafichePage";
import PianiRatePage from "@/pages/PianiRatePage";
import MaterialiPage from "@/pages/MaterialiPage";
import IscrizioniPage from "@/pages/IscrizioniPage";
import SollecitiPage from "@/pages/SollecitiPage";
import MateriePage from "@/pages/MateriePage";
import TestPage from "@/pages/TestPage";
import CorsiPubbliciPage from "@/pages/CorsiPubbliciPage";
import RegistroPagamentiPage from "@/pages/RegistroPagamentiPage";
import UscitaLezionePage from "@/pages/UscitaLezionePage";
import ImpostazioniPage from "@/pages/ImpostazioniPage";
import "@/App.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
      <div className="text-[#F7941E] font-brand text-2xl animate-pulse">ISTEFORM</div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PortalHome() {
  const { user } = useAuth();
  if (user) return <Navigate to="/app" replace />;
  return <LoginPage />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<PortalHome />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/iscrizioni-online" element={<PublicEnrollmentPage />} />
            <Route path="/uscita-lezione" element={<UscitaLezionePage />} />
            <Route path="/app" element={<Protected><DashboardLayout /></Protected>}>
              <Route index element={<DashboardHome />} />
              <Route path="classi" element={<ClassiPage />} />
              <Route path="calendario" element={<CalendarioPage />} />
              <Route path="conferenze" element={<ConferenzePage />} />
              <Route path="presenze" element={<PresenzePage />} />
              <Route path="materie" element={<MateriePage />} />
              <Route path="test" element={<TestPage />} />
              <Route path="anagrafiche" element={<AnagrafichePage />} />
              <Route path="piani-rate" element={<PianiRatePage />} />
              <Route path="solleciti" element={<SollecitiPage />} />
              <Route path="materiali" element={<MaterialiPage />} />
              <Route path="iscrizioni" element={<IscrizioniPage />} />
              <Route path="corsi-pubblici" element={<CorsiPubbliciPage />} />
              <Route path="registro-pagamenti" element={<RegistroPagamentiPage />} />
              <Route path="impostazioni" element={<ImpostazioniPage />} />
              <Route path="*" element={<Navigate to="/app" replace />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
